import React from 'react'
import { useTranslation } from 'react-i18next'
import AlertSuccess from '../NewAlert/AlertSuccess'
import RocketImg from '../../../static/assets/rocket.svg'

function NewsletterAlertSuccess() {
  const { t } = useTranslation()

  return (
    <AlertSuccess>
      <div> <RocketImg /> </div>
      <div>
        <h4>{t('newsletter.alert.success.title')}</h4>
        <p>{t('newsletter.alert.success.description')}</p>
      </div>
    </AlertSuccess>
  )
}

export default NewsletterAlertSuccess
